module.exports = __webpack_public_path__ + "img/工程.4de86fc4.gif";